import { useMemo } from 'react';

/**
 * Hook to determine animation capabilities based on device & network
 * Disables expensive animations on low-end devices and mobile for better UX
 */
function useAnimationPerformance() {
  return useMemo(() => {
    const isMobile = window.innerWidth <= 768;
    const isTablet = window.innerWidth <= 1024;
    const isHighDPI = window.devicePixelRatio > 1;

    // Check connection speed (if available)
    const connection = navigator?.connection;
    const effectiveType = connection?.effectiveType; // 4g, 3g, 2g, slow-2g
    const isSlowConnection = ['slow-2g', '2g', '3g'].includes(effectiveType);

    // Determine device class
    const isLowEndDevice = isMobile && (isSlowConnection || isHighDPI);

    return {
      // Enable/disable animation tiers
      enableAmbientAnimations: !isMobile && !isLowEndDevice,
      enableCodeTerminals: !isMobile && !isLowEndDevice,
      enableSpectrogramVisualizers: !isMobile && !isLowEndDevice,
      enableWaveEffects: !isMobile && !isLowEndDevice,

      // Throttle rates (ms between updates)
      scrollThrottleMs: isMobile ? 32 : 16,

      // Device info for debugging
      isMobile,
      isTablet,
      isHighDPI,
      isSlowConnection,
      isLowEndDevice,
      effectiveType,
    };
  }, []);
}

export default useAnimationPerformance;
